import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import UserImage from '../assets/images/user.png';
import { useSelector } from 'react-redux';
import { capitalizeFirstLetter } from './helpers/capitalizeFirstLetter';

export default function UserProfile({ isCollapsed }) {
  const userName = useSelector((state) => state.loginReducer.user?.firstName);
  const navigate = useNavigate();

  const handleLogoutClick = () => {
    localStorage.clear();
    navigate('/login');
  };

  return (
    <div className="user-account">
      <img
        src={UserImage}
        className="rounded-circle user-photo"
        alt="User Profile"
      />
      {!isCollapsed && (
        <Dropdown>
          <span>Welcome,</span>
          <Dropdown.Toggle
            variant="none"
            as="a"
            id="dropdown-basic"
            className="user-name"
            style={{ cursor: 'pointer' }}
          >
            <strong>{capitalizeFirstLetter(userName)}</strong>
          </Dropdown.Toggle>

          <Dropdown.Menu className="dropdown-menu-right account">
            <Dropdown.Item href="profilev2page" disabled>
              <i className="icon-user"></i>My Profile
            </Dropdown.Item>
            <Dropdown.Item href="appinbox" disabled>
              {' '}
              <i className="icon-envelope-open"></i>Messages
            </Dropdown.Item>
            <Dropdown.Item disabled>
              {' '}
              <i className="icon-settings"></i>Settings
            </Dropdown.Item>
            <li className="divider"></li>
            <Dropdown.Item onClick={handleLogoutClick}>
              {' '}
              <i className="icon-power"></i>Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      )}
      <hr />
    </div>
  );
}